import { OrganizationPermission } from '@gm-commercial/profile-model';

import { FUEL_CARD_AND_EXPENSES_FLAG } from '~/common/models/featureFlags.model';
import { RouteName } from '~/common/models/route.model';
import { lazyWithReload } from '~/common/utils/lazyWithReload';

const ExpensesView = lazyWithReload(
  () => import('~/routes/organizations/expenses/ExpensesView')
);

const ORGANIZATIONS_EXPENSES_ROUTES = {
  [RouteName.ORGANIZATIONS_EXPENSES]: {
    name: RouteName.ORGANIZATIONS_EXPENSES,
    path: '/organizations/:organizationsId/expenses',
    authorizedPerms: [OrganizationPermission.READ],
    element: ExpensesView,
    requiredFeatureFlags: [FUEL_CARD_AND_EXPENSES_FLAG],
  },
};

export default ORGANIZATIONS_EXPENSES_ROUTES;
